module.exports = __webpack_public_path__ + "static/media/case-builder__confirm.82fac927.png";